import {
  CREATE_SERVICE_IDENTIFIER_SUCCESS,
  FETCH_SERVICE_IDENTIFIER_SUCCESS,
  GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS,
  GET_SERVICE_IDENTIFIER_SUCCESS,
  SAVE_SERVICE_IDENTIFIER_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  data: [],
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SERVICE_IDENTIFIER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_SERVICE_IDENTIFIER_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_SERVICE_IDENTIFIER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_SERVICE_IDENTIFIER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case GET_SERVICE_IDENTIFIER_FROM_ASSET_SUCCESS: {
      return {
        ...state,
        data: action.data,
      }
    }

    default:
      return state;
  }
}
